import React, {ChangeEventHandler, ReactElement} from 'react';
import {Controller} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {FormControl, FormHelperText, makeStyles, Theme, createStyles} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import CustomInputField from '@components/system/FormInput/StyledOutlinedInput';
import {APP, DEFAULT_BLACK_COLOR} from 'src/style/variable';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorStyle: {
      display: 'contents'
    }
  })
)
interface FormCurrencyFieldProps {
  id: string;
  name: string;
  type: string;
  label?: string;
  placeholder: string;
  control: any;
  error: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  labelWidth?: number;
  defaultValue?: string | number;
  className?: string;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
  onChange?: ChangeEventHandler;
}
const FormCurrencyField = (props: FormCurrencyFieldProps): ReactElement => {
  const {t} = useTranslation();
  const classes = useStyles();
  const {
    id,
    name,
    type,
    placeholder,
    control,
    error,
    disabled,
    maxLength,
    labelWidth,
    defaultValue,
    className = '',
    decimalScale,
    fixedDecimalScale,
    onChange: onChangeCallback
  } = props;
  return (
    <FormControl
      error={!!error}
      fullWidth
      variant="outlined"
      className={`${className}`}>
      <Controller
        id={id}
        render={({value, onChange, onBlur}) => (
          <NumberFormat
            onBlur={onBlur}
            value={value}
            onChange={event => {
              onChange(event);
              if (onChangeCallback) {
                onChangeCallback(event);
              }
            }}
            customInput={CustomInputField}
            thousandSeparator={true}
            prefix={'$'}
            placeholder={placeholder}
            decimalScale={decimalScale}
            fixedDecimalScale={fixedDecimalScale}
            disabled={disabled}
            margin={'dense'}
          />
        )}
        control={control}
        style={{
          color: DEFAULT_BLACK_COLOR,
          fontFamily: APP.FONT_FAMILY.MEDIUM
        }}
        name={name}
        inputProps={{maxLength: maxLength ? String(maxLength) : null}}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        labelWidth={labelWidth || 0}
        defaultValue={defaultValue || ''}
        error={!!error}
      />
      {error && <FormHelperText className={classes.errorStyle}>{t(error)}</FormHelperText>}
    </FormControl>
  );
};
export default FormCurrencyField;
